import React from "react";
import { Link } from "react-router-dom";

const YEAR = new Date().getFullYear();

export const Footer = () => {
    return (
        <footer
            data-testid="site-footer"
            className="relative border-t border-white/[0.06] overflow-hidden"
        >
            <div className="absolute inset-0 starfield opacity-30 fade-edges pointer-events-none" />

            <div className="max-w-7xl mx-auto px-6 lg:px-10 pt-24 pb-12 relative">
                <div className="grid grid-cols-1 md:grid-cols-12 gap-12 md:gap-8">
                    <div className="md:col-span-5">
                        <p className="text-overline mb-6">Orion Road</p>
                        <p className="font-display text-3xl lg:text-4xl text-white/90 leading-[1.1] max-w-md">
                            Revenue and distribution for early-stage companies — without adding headcount.
                        </p>
                    </div>

                    <div className="md:col-span-3">
                        <p className="text-overline mb-6">Explore</p>
                        <ul className="flex flex-col gap-3 text-[14px] text-white/70">
                            <li><Link data-testid="footer-link-about" to="/about" className="hover-line">About</Link></li>
                            <li><Link data-testid="footer-link-services" to="/services" className="hover-line">Services</Link></li>
                            <li><Link data-testid="footer-link-how" to="/how-we-work" className="hover-line">How We Work</Link></li>
                            <li><Link data-testid="footer-link-contact" to="/contact" className="hover-line">Contact</Link></li>
                        </ul>
                    </div>

                    <div className="md:col-span-4">
                        <p className="text-overline mb-6">Get in touch</p>
                        <p className="text-[14px] text-white/70 leading-relaxed mb-6 max-w-sm">
                            We work with a small number of founders at any given time. If the timing's right, let's talk.
                        </p>
                        <Link
                            to="/contact"
                            data-testid="footer-cta-contact"
                            className="inline-flex items-center border border-white/25 text-white px-6 py-3 text-[12px] tracking-[0.24em] uppercase hover:bg-white hover:text-[#05070A] transition-colors duration-300"
                        >
                            Book a conversation
                        </Link>
                    </div>
                </div>

                <div className="mt-20 pt-8 border-t border-white/[0.06] flex flex-col md:flex-row md:items-end justify-between gap-6">
                    <p className="text-[11px] tracking-[0.24em] uppercase text-white/40">
                        © {YEAR} Orion Road · All rights reserved
                    </p>
                    <p className="text-[11px] tracking-[0.24em] uppercase text-white/40">
                        Quiet operator model
                    </p>
                </div>
            </div>

            <div
                aria-hidden="true"
                className="font-display select-none pointer-events-none text-white/[0.045] text-[28vw] leading-none tracking-tighter -mb-[8vw] text-center"
            >
                ORION
            </div>
        </footer>
    );
};

export default Footer;
